import { Layout as AntLayout, Menu } from 'antd';
import React from 'react';
import { useConfig, useBuildSidebarMenuItems, useUiConfig } from 'library';
import styled from 'styled-components';

const { Sider } = AntLayout;

const siderStyle: React.CSSProperties = {
  overflow: 'auto',
  height: '100vh',
  position: 'sticky',
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  scrollbarWidth: 'thin',
  scrollbarGutter: 'stable',
  zIndex: 5,
};

const Sidebar = () => {
  const { sidebarCollapsed, onSidebarCollapse } = useConfig();
  const { sidebarTitle, sidebarLogoUrl } = useUiConfig();

  const { menuItems, defaultOpenKeys, selectedKey } =
    useBuildSidebarMenuItems();

  return (
    <Sider
      width={300}
      style={siderStyle}
      collapsible
      collapsed={sidebarCollapsed}
      onCollapse={onSidebarCollapse}
    >
      <LogoSection $collapsed={sidebarCollapsed}>
        <Logo $collapsed={sidebarCollapsed}>
          {sidebarLogoUrl && <img src={sidebarLogoUrl} />}{' '}
          <Text>{sidebarTitle}</Text>
        </Logo>
      </LogoSection>
      <div style={{ margin: '12px 8px' }}>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={selectedKey ? [selectedKey] : []}
          defaultOpenKeys={defaultOpenKeys}
          items={menuItems}
        />
      </div>
    </Sider>
  );
};

const LogoSection = styled.div<{ $collapsed: boolean }>`
  height: 64px;
  display: flex;
  padding: ${({ $collapsed }) => ($collapsed ? '12px 20px;' : '12px 32px;')} 
  border-bottom: 1px solid ${({ theme }) => theme.colors.sidebarBorder};
`;

const Logo = styled.div<{ $collapsed: boolean }>`
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ $collapsed }) => ($collapsed ? '18px' : '20px')};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-flex;
  align-items: center;
  img {
    width: 40px;
  }
`;

const Text = styled.span`
  display: inline-block;
  margin-left: ${({ theme }) => theme.spacing.sm};
`;

export default Sidebar;
